import {isBrowser} from 'helpers/isBrowser';

export const getCookie = (name) => {
	if (!isBrowser()) return;
	const matches = document.cookie.match(new RegExp(
		`(?:^|; )${name.replace(/([\\.$?*|{}\\(\\)\\[\\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
};
